<template>
  <div class="border-dashed border-success mt-3 mb-3 p-1 bg-white shadow-sm stikybar-md">
    <div class="col-12" v-if="$store.getters.compare.length">
      <div v-if="$store.getters.compare.length" class="flex flex-row justify-between my-2 mb-0">
        <div class="pb-1 font-size-xs mb-2 border-bottom">
          Hai scelto {{ $store.getters.compare.length }} casinò per il confronto
        </div>
        <button class="btn btn-block btn-sm bg-yellow ml-auto text-black" @click="setComparisonMode">
          Confronta
        </button>
      </div>
    </div>
    <div class="d-flex flex-row text-center p-0">
      <div class="border" v-for="casino of $store.getters.compare" v-bind:key="casino.id">
        <div class="cancel-list shadow" @click="removeFromCompare(casino.id)"><i class="fe fe-x text-white"></i></div>
        <img class="img-fluid" :src="'https://img.casino2k.com/' + casino.logo" />
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-slider-component/theme/default.css';
  import store from '../store';

  export default {
    name: 'CompareBanner',
    components: {},
    methods: {
      setComparisonMode: () => {
        store.commit('setComparisonMode', true);
      },

      removeFromCompare: (id) => {

        const newGetter = store.getters.compare.filter(e => e.id != id);
        store.getters.results.find(e => e.id == id).compared = false;
        store.commit('setResults', store.getters.results)
        store.commit('setCompare', newGetter)
      }
    },
    props: [],
    store,
    watch: {},
  };
</script>